import gql from 'graphql-tag'

export const FRAGMENTS_FILE = gql`
  fragment fileFields on ItemFile {
    bucket
    cuid
    key
    title
    published
    id
    name
    dateUploaded
    imageHeight
    imageWidth
    uploadedBy
    url
    size
    originalMetadata
    location
    contentType
    useForPreview
    scrapeMetadata
    movedToS3
    processStatus
    pathOnDisk
    facetName
    facetClass
  }
`